import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import TagsInput from 'components/form/tagsinput'
import { cond, isEmpty, always, either, isNil, defaultTo } from 'ramda'
import withFieldError from 'components/form/with-error'

export const FacebookKeyword = ({
  input: { value, onChange, ...input },
  meta: { error, touched }
}) => (
  <div
    className={error && touched && 'has-error'}
    style={{ borderRadius: '2px' }}
  >
    <TagsInput
      inputProps={{
        placeholder: 'Enter keyword e.g. keyword',
        className: 'react-tagsinput-input input-medium',
        ...input,
        onBlur: input.onBlur.bind(input, value)
      }}
      addOnBlur
      value={value}
      onChange={onChange}
    />
  </div>
)

FacebookKeyword.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export const FacebookKeywordWithError = withFieldError(FacebookKeyword)

export const validate = cond([
  [either(isEmpty, isNil), always('Please enter a keyword')]
])

const FacebookKeywordField = ({ name }) => (
  <div>
    <Field
      name={`${name}.value`}
      component={FacebookKeywordWithError}
      validate={validate}
      format={defaultTo([])}
    />
  </div>
)

FacebookKeywordField.propTypes = {
  name: PropTypes.string
}

export default FacebookKeywordField



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/triggers/facebook/keyword/index.js